/**
 * Festivals & Celebrations Section Component
 * Displays a list of festivals with expandable cards
 * Follows Single Responsibility Principle
 */

import React from 'react';
import { motion } from 'framer-motion';
import { spacing } from '@/design-system/utils';
import { FestivalCard, Festival } from './FestivalCard';
import { SectionHeader } from '@/components/ui/section-header';

export interface FestivalsAndCelebrationsSectionProps {
  festivals: Festival[];
  onFestivalExpand?: (festivalTitle: string) => void;
}

export const FestivalsAndCelebrationsSection: React.FC<
  FestivalsAndCelebrationsSectionProps
> = ({ festivals, onFestivalExpand }) => {
  if (!festivals || festivals.length === 0) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.5,
        delay: 0.3,
        ease: [0.4, 0, 0.2, 1],
        opacity: { duration: 0.4 },
      }}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing[3],
      }}
    >
      <SectionHeader title='Festivals & Celebrations' />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: spacing[2],
        }}
      >
        {festivals.map((festival, index) => (
          <FestivalCard
            key={index}
            festival={festival}
            onExpand={onFestivalExpand}
            index={index}
          />
        ))}
      </div>
    </motion.div>
  );
};
